<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">用户管理</h2>
        </div>
        <div class="right">
          <el-button icon="el-icon-download"
                     @click="handleExport">导出</el-button>
          <el-button class="button"
                     type="primary"
                     @click="handleToCategory">分组管理</el-button>
          <el-button class="button"
                     type="primary"
                     @click="handleMemberCreate">添加用户</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="用户名"
                      prop="keyword">
          <el-input v-model="query.keyword"
                    placeholder="输入昵称/姓名/手机号"
                    @input="handleSearch"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="年份"
                      prop="apply_years">
          <el-select v-model="query.apply_years"
                     placeholder="请选择"
                     multiple
                     @change="handleSearch(true)"
                     clearable>
            <el-option label="2027年"
                       value="2027"></el-option>
            <el-option label="2026年"
                       value="2026"></el-option>
            <el-option label="2025年"
                       value="2025"></el-option>
            <el-option label="2024年"
                       value="2024"></el-option>
            <el-option label="2023年"
                       value="2023"></el-option>
            <el-option label="2022年"
                       value="2022"></el-option>
            <el-option label="2021年"
                       value="2021"></el-option>
            <el-option label="2020年"
                       value="2020"></el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="报考院校"
                      prop="college">
          <el-input v-model="query.college"
                    placeholder="输入院校名称/代码"
                    @input="handleSearch"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="报考专业"
                      prop="major">
          <el-input v-model="query.major"
                    placeholder="输入专业名称/代码"
                    @input="handleSearch"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="分组"
                      prop="category_ids">
          <el-select v-model="query.category_ids"
                     placeholder="请选择"
                     @change="handleSearch"
                     clearable
                     multiple
                     collapse-tags>
            <el-option v-for="item in categorys"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态"
                      prop="status">
          <el-select v-model="query.status"
                     placeholder="请选择"
                     @change="handleSearch"
                     clearable>
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来源">
          <el-select v-model="query.register_source_id"
                     placeholder="请选择"
                     @change="handleSearch"
                     clearable>
            <el-option v-for="item in clientList"
                       :key="item.id"
                       :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标记老师">
          <el-select v-model="query.sign_advicer_id"
                     placeholder="请选择"
                     @change="handleSearch"
                     clearable>
            <el-option v-for="item in AdminList"
                       :key="item.id"
                       :value="item.id"
                       :label="item.nickname"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标记时间">
          <el-date-picker class="datetime"
                          v-model="sign_advicer_time"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          :default-time="['00:00:00', '23:59:59']"
                          value-format="timestamp"
                          @change="handleSearch">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="注册时间">
          <el-date-picker class="datetime"
                          v-model="registerTime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          :default-time="['00:00:00', '23:59:59']"
                          value-format="timestamp"
                          @change="handleSearch">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">用户列表</p>
      </div>
      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%">
          <el-table-column type="expand"
                           v-if="false">
            <template slot-scope="scope">
              <el-form label-position="left"
                       class="table-expand">
                <el-form-item label="ID：">
                  <span>{{ scope.row.id }}</span>
                </el-form-item>
                <el-form-item label="昵称：">
                  <span>{{ scope.row.nickname }}</span>
                </el-form-item>
                <el-form-item label="真实姓名："
                              v-if="scope.row.realname">
                  <span>{{ scope.row.realname }}</span>
                </el-form-item>
                <el-form-item label="手机号"
                              v-if="scope.row.mobile">
                  <span>{{ scope.row.mobile }}</span>
                </el-form-item>
                <el-form-item label="用户分组："
                              v-if="scope.row.category_ids">
                  <span>{{ renderCategoryName(scope.row.category_ids) }}</span>
                </el-form-item>
                <el-form-item label="考研年份："
                              v-if="scope.row.applicant">
                  <span>{{ scope.row.applicant.apply_year }}</span>
                </el-form-item>
                <el-form-item label="报考院校："
                              v-if="scope.row.applicant">
                  <span>{{
                    scope.row.applicant && scope.row.applicant.college
                      ? scope.row.applicant.college.name
                      : ""
                  }}</span>
                </el-form-item>
                <el-form-item label="报考专业："
                              v-if="scope.row.applicant">
                  <span>{{
                    scope.row.applicant && scope.row.applicant.major
                      ? scope.row.applicant.major.name
                      : ""
                  }}</span>
                </el-form-item>
                <el-form-item label="注册来源："
                              v-if="scope.row.register_source_id">
                  <span v-if="scope.row.register_source_id">{{
                    formaterRegister_source_id(scope.row.register_source_id)
                  }}</span>
                  <span v-else-if="scope.row.register_source">{{
                    scope.row.register_source
                  }}</span>
                </el-form-item>
                <el-form-item label="注册时间：">
                  <span>{{
                    $moment(scope.row.register_time).format("YYYY-MM-DD HH:mm")
                  }}</span>
                </el-form-item>

                <el-form-item label="状态：">
                  <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">{{ scope.row.status == 1 ? "正常" : "禁用" }}</el-tag>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="nickname"
                           label="昵称"
                           min-width="120"
                           align="center">
          </el-table-column>
          <el-table-column prop="realname"
                           label="真实姓名"
                           min-width="120"
                           align="center">
          </el-table-column>
          <el-table-column prop="avatar"
                           label="头像"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <img class="avatar"
                   :src="scope.row.avatar" />
            </template>
          </el-table-column>
          <el-table-column prop="mobile"
                           label="手机号"
                           min-width="160"
                           align="center">
          </el-table-column>
          <el-table-column prop="mobile"
                           label="标记老师"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">

              <span v-if="scope.row.sign_advicer_id"
                    class="el-dropdown-link"
                    style="font-size: 12px; color: #8492a6; margin-left: 10px">
                {{getSignAdvicerName(scope.row.sign_advicer_id)}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown v-else
                           style="margin-left: 10px"
                           @command="command($event, scope.row.id)">
                <span class="el-dropdown-link"
                      style="font-size: 12px"
                      :style="{ color: scope.row.sign_advicer_id ? '#8492a6' : '' }">
                  {{getSignAdvicerName(scope.row.sign_advicer_id)}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="item.id"
                                    v-for="item in AdminList"
                                    :key="item.id">{{ item.nickname }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <div>
                {{ getSignAdvicerName(scope.row.sign_advicer_id) }}
              </div> -->
            </template>
          </el-table-column>
          <el-table-column label="标记时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.sign_advicer_time
                  ? $moment(scope.row.sign_advicer_time).format(
                      "YYYY-MM-DD HH:mm"
                    )
                  : "无"
              }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="category_ids"
                           label="用户分组"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              {{ renderCategoryName(scope.row.category_ids) }}
            </template>
          </el-table-column>
          <el-table-column label="考研年份"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.applicant ? scope.row.applicant.apply_year : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="报考院校"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.applicant && scope.row.applicant.college
                  ? scope.row.applicant.college.name
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="报考专业"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.applicant && scope.row.applicant.major
                  ? scope.row.applicant.major.name
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           width="120"
                           label="渠道邀请人"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.admin_inviter_admin_obj?scope.row.admin_inviter_admin_obj.nickname :'无' }}
            </template>
          </el-table-column>
          <el-table-column label="注册来源"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.register_source_id">{{
                formaterRegister_source_id(scope.row.register_source_id)
              }}</span>
              <span v-else-if="scope.row.register_source">{{
                scope.row.register_source
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="注册时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.register_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否禁言："
                           width="120"
                           align="center">
            <template slot-scope="
                           scope">
              <el-tag :type="scope.row.chat_disable_status == 1 ? 'danger' : ' success'">{{ scope.row.chat_disable_status == 1 ? "是" : "否" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">{{
                scope.row.status == 1 ? "正常" : "禁用"
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="注销"
                           width="90"
                           align="center">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="text"
                         @click="handleToMemberCancle(scope.row)">注销</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="220"
                           align="center"
                           fixed="right"
                           v-if="isfixed">
            <template slot-scope="scope">

              <el-button size="mini"
                         type="text"
                         @click="handleToMemberEdit(scope.row, scope.$index)">编辑</el-button>
              <el-button size="mini"
                         type="text"
                         @click="handleToMemberInfo(scope.row, scope.$index)">详情</el-button>
              <el-button size="mini"
                         type="text"
                         @click="handlePurchasedCourse(scope.row, scope.$index)">已购课程</el-button>

            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link"> ... </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom: 6px"><span @click="handleToMemberEdit(scope.row, scope.$index)"
                          style="font-size: 16px; color: #409eff">
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item command="b"
                                    style="margin-bottom: 6px"><span @click="handleToMemberInfo(scope.row, scope.$index)"
                          style="font-size: 16px; color: #409eff">
                      详情
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <div style="margin-right: 16px">
          共{{ otherCount }}条<span v-if="Number(otherCount) > 1000">,涉及隐私仅显示前1000条</span>
        </div>
        <el-pagination background
                       layout="prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <MemberCreate :visible="createDialog"
                  @close="createDialog = false"
                  @submit="fetchMemberList"></MemberCreate>
    <MemberEdit :visible="editDialog"
                :content="editRow"
                @close="editDialog = false"
                @submit="fetchMemberList"></MemberEdit>
    <InfoDialog :visible="infoDialogVisible"
                :content="editRow"
                @close="infoDialogVisible = false" />
    <PurchasedCourse :uid="uid"
                     :visible="purchasedCourseVisible"
                     @close="purchasedCourseVisible = false">
    </PurchasedCourse>
    <UserMess :visible="userVisible"
              :rowDetail="rowDetail"
              :isType="isType"
              @close="userClose()" />
  </div>
</template>

<script>
import {
  memberList,
  memberCategoryList,
  memberExport,
  memberUpdate,
  memberDELETE,
} from '@/api/member'
import UserMess from '@/components/dialog/senior/userMess'
import MemberCreate from '@/components/dialog/member/MemberCreate'
import MemberEdit from '@/components/dialog/member/MemberEdit'
import InfoDialog from '@/components/dialog/member/Info'
import PurchasedCourse from '@/components/dialog/member/PurchasedCourse'
import { clientList } from '@/api/operation'
import { adminList } from '@/api/admin'

export default {
  components: {
    MemberCreate,
    MemberEdit,
    InfoDialog,
    PurchasedCourse,
    UserMess,
  },
  data() {
    return {
      isType: false,
      userVisible: false,
      uid: null,
      purchasedCourseVisible: false,
      createDialog: false,
      editDialog: false,
      infoDialogVisible: false,
      editRow: {},
      sign_advicer_time: [],
      registerTime: [],
      query: {
        keyword: '',
        status: '',
        college: '',
        category_ids: '',
        major: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 1000,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '正常', value: '1' },
          { label: '禁用', value: '0' },
        ],
        bannerStatus: [
          { label: '禁言', value: '1' },
          { label: '正常', value: '0' },
        ],
      },
      categorys: [],
      results: [],
      clientList: [],
      isfixed: document.body.clientWidth < 820 ? false : 'right',
      otherCount: 0,
      AdminList: [],
      rowDetail: {},
    }
  },
  created() {
    this.parseQuery()
    this.fetchCategoryList()
    this.fetchMemberList()
    this.fetchClientList()
    this.fetchAdminList()
  },
  methods: {
    userClose() {
      this.userVisible = false
    },
    handleToMemberCancle(row) {
      console.log('row', row)
      this.$confirm('确定要注销该用户吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          memberDELETE({ id: row.id }).then((res) => {
            this.$message({
              message: '操作成功!',
              type: 'success',
            })
          })
        })
        .catch(() => {})
    },
    getSignAdvicerName(id) {
      if (id) {
        let obj = this.AdminList.find((item) => item.id == id)
        if (obj) {
          return obj.nickname
        }
      }
      return '无'
    },
    fetchAdminList() {
      adminList({
        isPaging: 0,
        role: 5,
        status: 1,
      }).then((res) => {
        this.AdminList = res.list || []
        // console.log("this.AdminList:", this.AdminList);
      })
      this.syncQuery()
    },
    command(e, id) {
      memberUpdate({
        id: id,
        sign_advicer_id: e,
      }).then((res) => {
        if (res.id) {
          this.$message({
            message: '标记成功!',
            type: 'success',
          })
          this.fetchMemberList()
        }
        // console.log("res:", res);
      })
    },
    // 已购课程
    handlePurchasedCourse(row) {
      this.uid = row.id
      this.purchasedCourseVisible = true
      // console.log("11",this.uid)
    },

    // 用户列表
    fetchMemberList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      if (params.category_ids) {
        params.category_ids = params.category_ids.filter((v) => v).join(',')
      }

      if (this.sign_advicer_time && this.sign_advicer_time.length) {
        params.start_sign_advicer_time = this.sign_advicer_time[0]
        params.end_sign_advicer_time = this.sign_advicer_time[1]
      }
      if (this.registerTime && this.registerTime.length) {
        params.start_register_time = this.registerTime[0]
        params.end_register_time = this.registerTime[1]
      }
      if (params.apply_years) {
        params.apply_years = params.apply_years.join(',')
      }
      params.is_get_chat = 1
      memberList(params).then((res) => {
        this.results = res.list || []
        if (res.count > 1000) {
          this.otherCount = res.count
          this.pageTotal = 1000
        } else {
          this.otherCount = res.count
          this.pageTotal = res.count || 0
        }
      })
      this.syncQuery()
    },
    // 分类列表请求
    fetchCategoryList() {
      memberCategoryList({ isPaging: 0, status: 1 }).then((res) => {
        this.categorys = res.list
      })
    },
    // 客户端列表请求
    fetchClientList() {
      clientList({ isPaging: 0 }).then((res) => {
        this.clientList = res.list
      })
    },
    // 用户数据导了同
    handleExport() {
      const params = Object.assign({}, this.query)
      if (params.category_ids) {
        params.category_ids = params.category_ids.filter((v) => v).join(',')
      }
      console.log('参数', params)
      memberExport(params).then((res) => {
        if (res) {
          window.open(res.url)
        }
      })
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchMemberList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchMemberList()
    },
    // 触发搜索按钮
    handleSearch() {
      // console.log("pp",this.sign_advicer_time)
      this.$set(this.query, 'pageIndex', 1)

      this.fetchMemberList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchMemberList()
    },
    // 分类管理
    handleToCategory() {
      this.$router.push(`/member/category`)
    },
    // 分类名称渲染
    renderCategoryName(ids) {
      if (!ids) {
        return ''
      }
      ids = ids.split(',')
      const list = this.categorys.filter((item) =>
        ids.includes(String(item.id))
      )
      if (list.length) {
        return list.map((v) => v.name).join('、')
      }
      return ''
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        1: '正常',
        0: '禁用',
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 用户编辑
    handleToMemberEdit(row) {
      this.isType = true
      console.log('row', row)
      this.rowDetail = row
      this.userVisible = true
      // this.editRow = Object.assign({}, row, {
      //   status: row.status == 1 ? true : false,
      // })
      // this.editDialog = true
    },
    // 用户创建
    handleMemberCreate() {
      this.createDialog = true
    },
    // 用户详情
    handleToMemberInfo(row) {
      this.editRow = Object.assign({}, row, {
        status: row.status == 1 ? true : false,
      })
      this.infoDialogVisible = true
    },
    // 解析URL请求参数
    parseQuery() {
      console.log(this.query.category_ids, 'parseQuery')
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.category_ids) {
        this.query.category_ids = this.query.category_ids.split(',')
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query)
      if (params.category_ids) {
        params.category_ids = params.category_ids.filter((v) => v).join(',')
      }
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        })
    },
    formaterRegister_source_id(val) {
      if (val != 0) {
        return this.clientList.find((v) => {
          return v.id == val
        }).name
      } else {
        return '无'
      }
    },
  },
}
</script>

<style scoped lang="less">
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .avatar {
      display: block;
      width: 48px;
      height: 48px;
      object-fit: cover;
      margin: 0 auto;
    }
    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
    }
  }
}
</style>
